import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./LeadershipSubPage.css";

const LeadershipTeam = () => (
  <div className="leadership-sub-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner
      title="Leadership Team"
      backLabel="Back to Leadership"
      backPath="/leadership"
    />

    <ScrollReveal variant="fadeUp">
    <section className="leadership-sub-content">
        <div className="leadership-sub-inner">
          <h2>Executive Leadership</h2>
          <p>
            The Leadership Team at Pawansut Holdings Limited drives day-to-day operations, strategy execution, and innovation. Our executives combine deep industry experience with a focus on customer value, digital transformation, and sustainable growth.
          </p>
          <p>
            The team works closely with the Board to implement approved strategies, manage risk, and deliver on our commitments to clients, investors, and employees.
          </p>
          <h3>Focus Areas</h3>
          <ul>
            <li>Strategy execution and business performance</li>
            <li>Product development and technology</li>
            <li>Risk, compliance, and operations</li>
            <li>People, culture, and talent development</li>
            <li>Stakeholder communication and investor relations</li>
          </ul>
        </div>
    </section>
    </ScrollReveal>
  </div>
);

export default LeadershipTeam;
